import { ResourceContextProvider, SimpleForm, Title, useNotify, useRedirect, useRefresh } from "react-admin";
import { CURRICULUMS, MODULES, StudentServicePath } from "utils/constants";
import BackButtonToolbar from "features/BackButtonToolbar";
import { useLocation, useParams } from "react-router-dom";
import CreateForm from "./CreateForm";
import dataProvider from "server/dataProvider";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { studentRequests } from "api/studentApi";
import { useNotifyError } from "utils/useNotifyError";

const CreateModule = () => {
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notifyError = useNotifyError();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const location = useLocation();
  const curriculumName = location.state?.curriculumName;

  const { id } = useParams();

  const handleSubmit = async data => {
    const payload = {
      nameBg: data.nameBg,
      nameEn: data.nameEn,
    };

    try {
      await dataProvider.customRequest(studentRequests.createCurriculumModule(id), payload, "POST");

      notify("Успешно създаване на модул за учебен план", { type: "success" });
      refresh();
      redirect(-1);
    } catch (err) {
      notifyError(err);
      handleConflictError(err);
    }
  };

  return (
    <>
      <Title title={`Създай модул за учебен план: ${curriculumName}`} />
      <BackButtonToolbar />
      <ResourceContextProvider value={`${StudentServicePath}${MODULES}/${CURRICULUMS}/${id}/create`}>
        <SimpleForm onSubmit={handleSubmit}>
          <CreateForm />
        </SimpleForm>
      </ResourceContextProvider>
      <ConflictErrorDialog />
    </>
  );
};

export default CreateModule;
